window.Products.HomeDecor.Placemat = function () {}
window.Products.HomeDecor.Placemat.inherits(window.Products.HomeDecor.HomeDecor)